import { render, staticRenderFns } from "./WangEditorV5.vue?vue&type=template&id=00c8d0f2&scoped=true"
import script from "./WangEditorV5.vue?vue&type=script&lang=js"
export * from "./WangEditorV5.vue?vue&type=script&lang=js"
import style0 from "./WangEditorV5.vue?vue&type=style&index=0&id=00c8d0f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c8d0f2",
  null
  
)

export default component.exports